import { RxMix } from "react-icons/rx";
import { BsApple } from "react-icons/bs";
import { LiaJava } from "react-icons/lia";
import { FaFlutter } from "react-icons/fa6";
import { IoLogoApple } from "react-icons/io";
import { PiMonitorFill } from "react-icons/pi";
import { TbBrandKotlin } from "react-icons/tb";
import { MdDevicesOther } from "react-icons/md";
import { TbDeviceIpad } from "react-icons/tb";
import { MdConnectedTv } from "react-icons/md";
import { FiActivity, FiRefreshCw, FiShield, FiZap, FiGlobe, FiTrendingUp, FiUsers, FiLayout, FiCpu, FiSearch } from "react-icons/fi";
import { FaBug, FaSwift, FaWindows } from "react-icons/fa";
import { FcAndroidOs, FcTouchscreenSmartphone } from "react-icons/fc";
import { SiDotnet, SiGooglemaps, SiIonic, SiKnative } from "react-icons/si";
import { IoLayersSharp, IoLogoCapacitor, IoLogoElectron, IoSparkles } from "react-icons/io5";
import { FaReact, FaNodeJs, FaAws } from "react-icons/fa";
import { SiNextdotjs, SiPython, SiMongodb, SiPostgresql, SiFirebase } from "react-icons/si";

export const mobileAppMock = [
  {
    q: "Why should I hire a mobile app development company in India for my business?",
    a: "Hiring a mobile app development company in India gives you access to skilled developers, cost-effective solutions, and innovative app designs. Indian companies are experienced in building apps for startups, SMEs, and large enterprises, ensuring high-quality apps delivered on time.",
  },
  {
    q: "What kind of services can I expect from an app development company in India?",
    a: "An app development company in India offers end-to-end services including iOS and Android app development, UI/UX design, app testing, maintenance, and post-launch support. They also help bring your unique app idea to life with custom solutions.",
  },
  {
    q: "Why choose a mobile app development company in Delhi over other cities?",
    a: "Delhi has a strong tech ecosystem with experienced developers, competitive pricing, and a track record of delivering apps for businesses across India and globally. Local companies also offer personalized support and easy communication.",
  },
  {
    q: "How can I find the right mobile app developer in Delhi for my project?",
    a: "Look for developers with a strong portfolio, client reviews, and expertise in the platform you need (iOS, Android, or cross-platform). A good developer will guide you through planning, design, development, and post-launch support.",
  },
];

export const mobileAppTech = [
  {
    id: "android",
    label: "Android",
    icon: <FcAndroidOs size={28} />,
    techs: [
      { name: "Java", emoji: <LiaJava color="red" /> },
      { name: "Kotlin", emoji: <TbBrandKotlin color="purple" /> },
    ],
  },
  {
    id: "ios",
    label: "IOS",
    icon: <IoLogoApple size={30} color="pink" />,
    techs: [
      { name: "Swift", emoji: <FaSwift color="orange" /> },
      { name: "Objective-C", emoji: <SiKnative color="blue" /> },
    ],
  },
  {
    id: "hybrid",
    label: "Hybrid",
    icon: <RxMix size={26} color="yellow" />,
    techs: [
      { name: "React Native", emoji: <FaReact color="#61DAFB" /> },
      { name: "Flutter", emoji: <FaFlutter color="#02569B" /> },
      { name: "Ionic", emoji: <SiIonic color="#3880FF" /> },
      { name: "Capacitor", emoji: <IoLogoCapacitor color="#87CEEB" /> },
    ],
  },
  {
    id: "service-types",
    label: "Service types",
    icon: <MdDevicesOther size={26} color="#4A90E2" />,
    techs: [
      { name: "Firebase", emoji: <SiFirebase color="#FFCA28" /> },
      { name: "Google APIs", emoji: <SiGooglemaps color="#EA4335" /> },
    ],
  },
  {
    id: "windows",
    label: "Windows App",
    icon: <FaWindows size={26} color="#00A4EF" />,
    techs: [
      { name: ".NET MAUI", emoji: <SiDotnet color="#512BD4" /> },
      { name: "Electron", emoji: <IoLogoElectron color="#61DAFB" /> },
    ],
  },
];

export const mobileAppBenefits = [
  {
    icon: <FiShield className="w-8 h-8" />,
    title: "High Performance",
    desc: "We build apps optimized for speed and reliability, ensuring a smooth user experience across all devices.",
  },
  {
    icon: <FiZap className="w-8 h-8" />,
    title: "Agile Development",
    desc: "Our agile approach ensures rapid delivery and the flexibility to adapt to changing requirements.",
  },
  {
    icon: <FiGlobe className="w-8 h-8" />,
    title: "Cross-Platform Experts",
    desc: "Reach a wider audience with apps that work seamlessly on both iOS and Android.",
  },
  {
    icon: <FiTrendingUp className="w-8 h-8" />,
    title: "Scalable Solutions",
    desc: "We design our apps to grow with your business, handling increased loads without a hitch.",
  },
  {
    icon: <FiUsers className="w-8 h-8" />,
    title: "User-Centered Design",
    desc: "Every app we build starts with the user, focusing on intuitive interfaces and engaging experiences.",
  },
];

export const mobileAppServices = [
  {
    icon: <FcAndroidOs size={36} />,
    title: "Android Application Development",
    description: "We create scalable Android applications focused on performance, usability, and long-term business growth.",
    image: "/images/MobileAppDevelopment/Android-Development.png",
    link: "/android-app-development-services-india",
  },
  {
    icon: <IoLogoApple size={36} />,
    title: "iOS Mobile App Development",
    description: "Build secure and high-performing iOS applications designed for the Apple ecosystem.",
    image: "/images/MobileAppDevelopment/iOS-Custom.png",
    link: "/ios-app-development-services-india",
  },
  {
    icon: <IoLayersSharp size={36} />,
    title: "Hybrid Mobile App Solutions",
    description: "Develop cross-platform applications with faster deployment and seamless user experiences.",
    image: "/images/MobileAppDevelopment/Hybrid-Dev.png",
    link: "/hybrid-app-development-services-india",
  },
  {
    icon: <TbDeviceIpad size={36} />,
    title: "iPad Application Development",
    description: "Design responsive iPad applications optimized for larger screens and interactive experiences.",
    image: "/images/MobileAppDevelopment/Ipad_App_Development.png",
    link: "/ipad-app-development-services-india",
  },
  {
    icon: <MdConnectedTv size={36} />,
    title: "OTT App Development Services",
    description: "Build advanced OTT applications with smooth streaming and multi-device compatibility.",
    image: "/images/MobileAppDevelopment/OTT_Plarform_Dev.png",
    link: "/ott-platform-development-services-india",
  },
  // {
  //   icon: <PiMonitorFill size={36} />,
  //   title: "Windows App Development",
  //   description: "Expand your reach with high-performing Windows applications. Designed for seamless user experiences and visual appeal across all platforms.",
  //   image: "/images/MobileAppDevelopment/Windows-Legacy.jpg",
  //   link: "/windows-app-development-services-india",
  // },
];

export const mobileAppProcessSteps = [
  {
    step: "01",
    title: "Strategy & Discovery",
    description: "We dive deep into your business goals and user needs to define the perfect app roadmap.",
    points: ["Market Research", "Feature Prioritization", "User Persona Identification"],
  },
  {
    step: "02",
    title: "UX/UI Design",
    description: "Our designers create intuitive and visually stunning interfaces that users love.",
    points: ["Wireframing", "Interactive Prototypes", "Visual Design"],
  },
  {
    step: "03",
    title: "Agile Development",
    description: "We use the latest tech stacks to build robust, scalable, and high-performance apps.",
    points: ["Front-end & Back-end", "API Integration", "Weekly Sprints"],
  },
  {
    step: "04",
    title: "Testing & Deployment",
    description: "Rigorous testing ensures a bug-free launch, followed by expert submission to app stores.",
    points: ["Security Audit", "Beta Testing", "App Store Optimization"],
  },
];

export const techIcons = {
  Java: "/images/icons/java.webp",
  Kotlin: "/images/icons/kotlin.webp",
  Swift: "/images/icons/swift.webp",
  ReactNative: "/images/icons/reactnative.webp",
  Flutter: "/images/icons/flutter.webp",
  Ionic: "/images/icons/ionic.webp",
  Firebase: "/images/icons/firebase.webp",
  DotNet: "/images/icons/dotnet.webp",
  Electron: "/images/icons/electron.webp",
};

export const webTechIcons = {
  React: "/images/icons/reactnative.webp",
  "Node.js": "/images/icons/nodejs.webp",
  "Next.js": "/images/icons/nextjs(1).webp",
  Python: "/images/icons/python.webp",
  MongoDB: "/images/icons/mongodb.webp",
  PostgreSQL: "/images/icons/postgresql.webp",
  AWS: "/images/icons/aws.webp",
  Firebase: "/images/icons/firebase.webp",
};

export const techStack = ["Java", "Kotlin", "Swift", "ReactNative", "Flutter", "Ionic", "Firebase", "DotNet", "Electron"];

export const webTechStack = ["React", "Node.js", "Next.js", "Python", "MongoDB", "PostgreSQL", "AWS", "Firebase"];

export const whyChoose = [
  {
    title: "Stable and transparent process",
    content:
      "As a top development company for mobile apps, we use close growth to make your project flexible and efficient. Open communication and regular updates keep you informed. This helps us respond to any change and ensures that your answer is integrated into each stage of the development process.",
  },
  {
    title: "Cross Industry Competence",
    content: "Our mobile app development solutions are designed to meet special requirements for industries such as health care, finance, retail and logistics.",
  },
  {
    title: "Advanced technologies",
    content:
      "We use the most advanced equipment and frameworks to develop mobile applications with high performance. Our mobile app development services are designed for scalability, security, and intuitive user experiences.",
  },
  {
    title: "Customer-focused approach",
    content: "In our mobile app development company, your vision is our top priority. We work with you in each step to offer a solution that coincides fully with business goals.",
  },
];

export const expertiseItems = [
  {
    num: 1,
    title: "Custom Mobile Apps",
    desc: "We provide customised mobile app development services at Tycho technologies, engineered according to your individual business requirements. Our professional team constructs highly efficient and scalable apps with beautiful interfaces and user-friendly designs for iOS, Android, and cross-platform development. Regardless of the type of business application you want to have—a business utility tool, on-demand service app, or enterprise system—your personal user experience is assured, accompanied by strong security features and cutting-edge technology, helping your company prosper.",
  },
  {
    num: 2,
    title: "eCommerce Apps",
    desc: "We at Tycho technologies develop robust eCommerce applications designed to facilitate seamless shopping and increase the volume of online sales. Our solutions comprise of easy-to-navigate UI/UX, tailored suggestions, secure payment gateways, real-time inventory control, and multi-platform support for both Android and iOS devices. From startups to seasoned retail businesses, we provide rich mobile commerce applications that are too agile features and scaling to boost customer interaction and conversions.",
  },
  {
    num: 3,
    title: "Enterprise Apps",
    desc: "From automating communications to storing data in the cloud, our solutions incorporate such functionalities and feature real-time analytics which makes us capable of living up to specific industry demands. We construct high-performance enterprise applications to improve processes, productivity, and efficiency, as well as enable effortless digital transformation of organisations. Be it a custom solution, workflow management system, CRM, or ERP, we provide it all while maintaining scalability.",
  },
  {
    num: 4,
    title: "Social Networking Apps",
    desc: "At Tycho technologies, our mobile app development services for social networking that users find appealing and which fosters social engagements. Our services comprise a range of features such as instant messaging, media distribution, customised feeds, user accounts, alerts, and robust privacy protection. From community and dating platforms to professional networking applications, we offer exceptional experience while ensuring optimum engagement and retention.",
  },
  {
    num: 5,
    title: "Educational Apps",
    desc: "We create engaging and interactive learning apps that enrich educational experiences for learners, professionals, and organisations. Our offerings range from virtual classrooms, video conferencing sessions, quizzes, game-based learning, tracking of progress, and AI-powered personalisation. Whether an e-learning solution, corporate training application, or a tutoring app, we provide effortless access, immersive content presentation, and a scalable framework to serve varying learning requirements.",
  },
  {
    num: 6,
    title: "Gaming Apps",
    desc: "At Tycho technologies, we make amazing gaming apps with really high-end graphics, amazing and smooth gameplay, and very engaging user experiences. Our expertise includes 2D and 3D game development, multiplayer integration, AR/VR gaming, in-app purchases, and real-time analytics. Whether it is a simple game, such as casual games, strategy games, adventure or simulation games, we do everything using the latest technologies that give you interactive experience with great scalability and fun.",
  },
];

export const supportItems = [
  {
    icon: FiRefreshCw,
    title: "App Updates",
    desc: "We assist in keeping your app in sync with the latest features to keep it entirely compatible with newer iOS and Android OS releases.",
  },
  {
    icon: FaBug,
    title: "Bug Fixes",
    desc: "Our team keeps a close eye on your app spotting and fixing any problems that might hurt how well it works, how safe it is, or how happy users are.",
  },
  {
    icon: FiActivity,
    title: "Performance Monitoring",
    desc: "We provide monitoring of the ongoing performance, monitoring of leading metrics such as loading time, crash reports and server response time.",
  },
  {
    icon: IoSparkles,
    title: "Feature Enhancements",
    desc: "We assist in adding new capabilities, improving current functions, and fine-tuning the interface to keep users engaged over time.",
  },
];
